var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.546,
    height: 14.543,
    viewBox: "0 0 14.546 14.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1332",
    "data-name": "Group 1332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1331",
    "data-name": "Group 1331"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_194",
    "data-name": "Ellipse 194",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(10.822 5.496)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4572",
    "data-name": "Path 4572",
    d: "M12.27,1.136h-.738V.568a.568.568,0,1,0-1.136,0v.568H7.811V.568a.568.568,0,1,0-1.136,0v.568H4.118V.568a.568.568,0,0,0-1.136,0v.568h-.71A2.275,2.275,0,0,0,0,3.408V12.27a2.275,2.275,0,0,0,2.272,2.272H6.618a.568.568,0,0,0,0-1.136H2.272A1.137,1.137,0,0,1,1.136,12.27V3.408A1.137,1.137,0,0,1,2.272,2.272h.71V2.84a.568.568,0,1,0,1.136,0V2.272H6.675V2.84a.568.568,0,0,0,1.136,0V2.272H10.4V2.84a.568.568,0,1,0,1.136,0V2.272h.738A1.137,1.137,0,0,1,13.41,3.408V6.646a.568.568,0,0,0,1.136,0V3.408A2.275,2.275,0,0,0,12.27,1.136Z",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4573",
    "data-name": "Path 4573",
    d: "M273.437,270a3.437,3.437,0,1,0,3.437,3.437A3.437,3.437,0,0,0,273.437,270Zm0,5.737a2.3,2.3,0,1,1,2.3-2.3A2.3,2.3,0,0,1,273.437,275.737Z",
    transform: "translate(-262.331 -262.331)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4574",
    "data-name": "Path 4574",
    d: "M372.392,331.164h-.256v-.6a.568.568,0,0,0-1.136,0v1.164a.568.568,0,0,0,.568.568h.824a.568.568,0,1,0,0-1.136Z",
    transform: "translate(-360.463 -320.627)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_195",
    "data-name": "Ellipse 195",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(8.159 5.496)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_196",
    "data-name": "Ellipse 196",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(5.496 8.159)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_197",
    "data-name": "Ellipse 197",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(2.832 5.496)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_198",
    "data-name": "Ellipse 198",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(2.832 8.159)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_199",
    "data-name": "Ellipse 199",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(2.832 10.822)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_200",
    "data-name": "Ellipse 200",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(5.496 10.822)",
    fill: "#009f7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_201",
    "data-name": "Ellipse 201",
    cx: 0.444,
    cy: 0.444,
    r: 0.444,
    transform: "translate(5.496 5.496)",
    fill: "#009f7c"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGreen);
export default __webpack_public_path__ + "static/media/calendar-green.f7192d57a0a1db066834672eec45db99.svg";
export { ForwardRef as ReactComponent };